<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{ 'LIQUID_TYPE_TITLE' | globalTranslate }}</h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="('CLOSE' | globalTranslate)" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-striped d-none d-lg-block modal-table">
      <thead>
        <tr class="header-sty">
          <th scope="col">{{'LIQUID_TYPE_STATIC_TEXT1' | globalTranslate }}</th>
          <th scope="col">{{'LIQUID_TYPE_STATIC_TEXT2' | globalTranslate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{'LIQUID_TYPE1' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE1_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE2' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE2_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE3' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE3_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE4' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE4_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td [ngStyle]="isGlobalLang() ? {'overflow-wrap': 'break-word'} : {}">{{'LIQUID_TYPE5' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE5_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE6' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE6_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE7' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE7_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td [ngStyle]="isGlobalLang() ? {'overflow-wrap': 'break-word'} : {}">{{'LIQUID_TYPE8' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE8_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td [ngStyle]="isGlobalLang() ? {'overflow-wrap': 'break-word'} : {}">{{'LIQUID_TYPE9' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE9_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE10' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE10_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE11' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE11_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE12' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE12_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td [ngStyle]="isGlobalLang() ? {'overflow-wrap': 'break-word'} : {}">{{'LIQUID_TYPE13' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE13_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE14' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE14_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE15' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE15_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE16' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE16_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE17' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE17_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE18' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE18_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE19' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE19_DESCRIPTION' | globalTranslate }}{{'LIQUID_TYPE19_DESCRIPTION_01' | globalTranslate }}<span dir="ltr"> 401(k), 403(b)</span>{{ 'LIQUID_TYPE19_DESCRIPTION_02' | globalTranslate}}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE20' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE20_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE21' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE21_DESCRIPTION' | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{'LIQUID_TYPE22' | globalTranslate }}</td>
          <td>{{'LIQUID_TYPE22_DESCRIPTION' | globalTranslate }}</td>
        </tr>
      </tbody>
    </table>
    <div class="d-lg-none nh-table-mobile">
      <div class="mobile-table-header">{{'LIQUID_TYPE1' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE1_DESCRIPTION' | globalTranslate }}
      </div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE2' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE2_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE3' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE3_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE4' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE4_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE5' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE5_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header"> {{'LIQUID_TYPE6' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE6_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE7' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE7_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE8' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE8_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE9' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE9_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE10' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE10_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE11' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE11_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE12' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE12_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE13' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE13_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE14' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE14_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE15' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE15_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE16' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE16_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE17' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE17_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE18' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE18_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE19' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE19_DESCRIPTION' | globalTranslate }}{{'LIQUID_TYPE19_DESCRIPTION_01' | globalTranslate }} <span dir="ltr">401(k), 403(b)</span>{{ 'LIQUID_TYPE19_DESCRIPTION_02' | globalTranslate}}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE20' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE20_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE21' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE21_DESCRIPTION' | globalTranslate }}</div><br>
      <div class="mobile-table-header">{{'LIQUID_TYPE22' | globalTranslate }}</div>
      <hr>
      <div class="mobile-table-data">{{'LIQUID_TYPE22_DESCRIPTION' | globalTranslate }}</div><br>
    </div>
  </div>
